import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The user picks a skill from the composer Actions menu (Saved skills catalog or blended search results)',
  name: 'agent_actions_menu_skill_selected',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The selected skill id',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the user had typed a non-empty search query when selecting the skill',
      name: 'via_search',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
